import actionTypes from '../actionTypes';

export function getColumnList(data) {
	return {
		type: actionTypes.GET_COLUMN_LIST,
		payload: data,
	};
}
export function getColumnListSuccess(result) {
	return {
		type: actionTypes.GET_COLUMN_LIST_SUCCESS,
		payload: result,
	};
}
export function getColumnListFailure(error) {
	return {
		type: actionTypes.GET_COLUMN_LIST_FAILURE,
		payload: error,
	};
}

export function setColumnPreferences(data) {
	return {
		type: actionTypes.SET_COLUMN_PREFERENCES,
		payload: data,
	};
}

export function setColumnPreferencesTable(data) {
	return {
		type: actionTypes.SET_COLUMN_PREFERENCES_TABLE,
		payload: data,
	};
}

export function setColumnPreferencesFailure(data) {
	return {
		type: actionTypes.SET_COLUMN_PREFERENCES_FAILURE,
		payload: data,
	};
}

export function setColumnPreferencesSuccess(data) {
	return {
		type: actionTypes.SET_COLUMN_PREFERENCES_SUCCESS,
		payload: data,
	};
}

export function getUserPreferences(data) {
	return {
		type: actionTypes.GET_USER_PREFERENCES,
		payload: data,
	};
}
export function getUserPreferencesSuccess(data) {
	return {
		type: actionTypes.GET_USER_PREFERENCES_SUCCESS,
		payload: data,
	};
}
export function getUserPreferencesFailure(data) {
	return {
		type: actionTypes.GET_USER_PREFERENCES_FAILURE,
		payload: data,
	};
}

export function setIsDrawerOpen(payload) {
	return {
		type: actionTypes.SET_IS_DRAWER_OPEN,
		payload,
	};
}

export function setIsMetricsOpen(payload) {
	return {
		type: actionTypes.SET_IS_METRICS_OPEN,
		payload,
	};
}
